import { isV2orV1Widget, transformBrandIds } from '../helper';
const transformBasicData = (widgetData) => {
    if (!widgetData) {
        return {};
    }
    const { isDesktop, parameters, positionInParent, trackingData, transaction_id: transactionId, store, pagePrefix, tracking_metadata, previewMode, pwType, wtype, cwType, } = widgetData;
    // if parentWidget is not available then it will take wtype value this is applicable to PRODUCT_WIDGET's and STORY widget.
    const wType = pwType || wtype;
    const newTrackingData = Object.assign({}, trackingData);
    const { tile_id: trackingParameters, categories, brands, brand_ids, } = (parameters === undefined ? widgetData : parameters);
    newTrackingData.namespace2 = trackingParameters;
    newTrackingData.position2 = positionInParent;
    newTrackingData.transaction_id = transactionId;
    newTrackingData.categories = categories;
    newTrackingData.wtype = wType || '';
    newTrackingData.wtype_version = isV2orV1Widget(wType) || 'v1';
    newTrackingData.brand_ids = transformBrandIds(brands || brand_ids);
    newTrackingData.dn_tracking_metadata = tracking_metadata ? JSON.stringify(tracking_metadata) : '';
    return {
        id: widgetData.wid || widgetData.id,
        widgetType: widgetData.wtype,
        positionInParent: widgetData.positionInParent,
        inventoryName: widgetData.inventoryName,
        params: {},
        children: [],
        inheritParams: {},
        trackingData: newTrackingData,
        isDesktop: !!isDesktop,
        store,
        pagePrefix,
        previewMode,
        pwType,
        cwType,
    };
};
export default transformBasicData;
